import { render, staticRenderFns } from "./VCustomerSummary.vue?vue&type=template&id=2e397b6c&"
import script from "./VCustomerSummary.vue?vue&type=script&lang=js&"
export * from "./VCustomerSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports